"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVerifyEmailConfirmResponseDto = instanceOfVerifyEmailConfirmResponseDto;
exports.VerifyEmailConfirmResponseDtoFromJSON = VerifyEmailConfirmResponseDtoFromJSON;
exports.VerifyEmailConfirmResponseDtoFromJSONTyped = VerifyEmailConfirmResponseDtoFromJSONTyped;
exports.VerifyEmailConfirmResponseDtoToJSON = VerifyEmailConfirmResponseDtoToJSON;
exports.VerifyEmailConfirmResponseDtoToJSONTyped = VerifyEmailConfirmResponseDtoToJSONTyped;
/**
 * Check if a given object implements the VerifyEmailConfirmResponseDto interface.
 */
function instanceOfVerifyEmailConfirmResponseDto(value) {
    if (!('isEmailVerified' in value) || value['isEmailVerified'] === undefined)
        return false;
    return true;
}
function VerifyEmailConfirmResponseDtoFromJSON(json) {
    return VerifyEmailConfirmResponseDtoFromJSONTyped(json, false);
}
function VerifyEmailConfirmResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isEmailVerified': json['isEmailVerified'],
    };
}
function VerifyEmailConfirmResponseDtoToJSON(json) {
    return VerifyEmailConfirmResponseDtoToJSONTyped(json, false);
}
function VerifyEmailConfirmResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'isEmailVerified': value['isEmailVerified'],
    };
}
